/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CertPinDTO,
    CertPinDTOFromJSON,
    CertPinDTOFromJSONTyped,
    CertPinDTOToJSON,
} from './CertPinDTO';
import {
    ContactDTO,
    ContactDTOFromJSON,
    ContactDTOFromJSONTyped,
    ContactDTOToJSON,
} from './ContactDTO';

/**
 * 
 * @export
 * @interface ServicePlatformDTO
 */
export interface ServicePlatformDTO {
    /**
     * 
     * @type {string}
     * @memberof ServicePlatformDTO
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ServicePlatformDTO
     */
    directCalls?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServicePlatformDTO
     */
    systemId?: string;
    /**
     * 
     * @type {string}
     * @memberof ServicePlatformDTO
     */
    systemName?: string;
    /**
     * 
     * @type {Array<ContactDTO>}
     * @memberof ServicePlatformDTO
     */
    contacts?: Array<ContactDTO>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ServicePlatformDTO
     */
    attributes?: { [key: string]: string; };
    /**
     * 
     * @type {Array<CertPinDTO>}
     * @memberof ServicePlatformDTO
     */
    certPins?: Array<CertPinDTO>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServicePlatformDTO
     */
    serviceConsumers?: Array<string>;
}

export function ServicePlatformDTOFromJSON(json: any): ServicePlatformDTO {
    return ServicePlatformDTOFromJSONTyped(json, false);
}

export function ServicePlatformDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServicePlatformDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'directCalls': !exists(json, 'directCalls') ? undefined : json['directCalls'],
        'systemId': !exists(json, 'systemId') ? undefined : json['systemId'],
        'systemName': !exists(json, 'systemName') ? undefined : json['systemName'],
        'contacts': !exists(json, 'contacts') ? undefined : ((json['contacts'] as Array<any>).map(ContactDTOFromJSON)),
        'attributes': !exists(json, 'attributes') ? undefined : json['attributes'],
        'certPins': !exists(json, 'certPins') ? undefined : ((json['certPins'] as Array<any>).map(CertPinDTOFromJSON)),
        'serviceConsumers': !exists(json, 'serviceConsumers') ? undefined : json['serviceConsumers'],
    };
}

export function ServicePlatformDTOToJSON(value?: ServicePlatformDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'directCalls': value.directCalls,
        'systemId': value.systemId,
        'systemName': value.systemName,
        'contacts': value.contacts === undefined ? undefined : ((value.contacts as Array<any>).map(ContactDTOToJSON)),
        'attributes': value.attributes,
        'certPins': value.certPins === undefined ? undefined : ((value.certPins as Array<any>).map(CertPinDTOToJSON)),
        'serviceConsumers': value.serviceConsumers,
    };
}

